import { STRAPI_LANGUAGES } from '@/lib/constants';
import { Language } from '@/lib/translate';

type Environment = 'local' | 'dev' | 'prod';

const API_URL: Record<Environment, string> = {
	local: 'http://localhost:5033',
	dev: 'https://viber-strapi-195f1ebb142a.herokuapp.com',
	prod: 'http://3.65.32.210:5033',
};

export const getImage = (preview: any) => preview?.file?.url ?? preview?.url;

export const fetchAPI = async (
	path: string,
	params?: {
		url?: string;
		sort?: string;
		limit?: number;
		query?: string;
		lang?: Language;
		populate?: string[];
	},
) => {
	try {
		const queryParams: string[] = [
			'locale=' + STRAPI_LANGUAGES[params?.lang ?? 'en'],
		];

		if (params?.sort) queryParams.push(`sort[0]=${params.sort}`);

		if (params?.limit)
			queryParams.push(`pagination[start]=0&pagination[limit]=${params.limit}`);

		if (params?.url) queryParams.push(`filters[url][$eq]=${params.url}`);

		if (params?.query) queryParams.push(params.query);

		queryParams.push(
			params?.populate
				? params.populate
						.map((item, index) => `populate[${index}]=${item}`)
						.join('&')
				: 'populate=*',
		);

		const url =
			API_URL[process.env.APP_ENV as Environment] +
			'/api' +
			path +
			'?' +
			queryParams.join('&');

		const response = await fetch(url);
		const data = await response.json();

		return data;
	} catch (error) {
		console.error(error);

		return null;
	}
};
